"use strict";
require('./CompanyGdprContactsService.js');
var LIMIT = 20;
CompanyGdprContactListCtrl.$inject = [
  '$scope',
  '$stateParams',
  'growl',
  '$translate',
  'CompanyGdprContactsService',
  'gdprContacts'];

function CompanyGdprContactListCtrl(
  $scope,
  $stateParams,
  growl,
  $translate,
  CompanyGdprContactsService,
  gdprContacts) {

  $scope.gdprContacts = gdprContacts;

  $scope.delete = function(gdprContact) {
    CompanyGdprContactsService.delete({companyId: $stateParams.companyId, contactId: gdprContact.id}, function() {
      growl.addSuccessMessage($translate.instant('gdpr.contact.delete-success'));
      $scope.gdprContacts.splice($scope.gdprContacts.indexOf(gdprContact), 1);
    }, function(){
      growl.addErrorMessage($translate.instant('gdpr.contact.delete-failure'));
    });
  };
}

CompanyGdprContactListCtrl.resolve = {
  gdprContacts: ['$stateParams', 'CompanyGdprContactsService', function($stateParams, CompanyGdprContactsService) {
    return CompanyGdprContactsService.query({
      companyId: $stateParams.companyId,
      limit: (LIMIT + 1), offset: ($stateParams.page|0) * LIMIT
    }).$promise;
  }]
};

module.exports  = CompanyGdprContactListCtrl;

angular.module("dokiv")
  .controller("CompanyGdprContactListCtrl", CompanyGdprContactListCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/gdpr/contacts/CompanyGdprContactListCtrl.js
// module id = 356
// module chunks = 0